import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { isFeatureUsed } from 'src/utils/features'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import List from 'src/components/List'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'
import styles from './ServicesList.module.less'

class ServicesList extends Component {
  componentDidMount() {
    const { history, features } = this.props

    // Redirect home if this feature is not enabled
    if (!isFeatureUsed('services', features)) {
      history.push('/')
    }
  }

  listItemClick = item => {
    const { history } = this.props
    history.push(
      '/services/map/' + item.mapFilterType + '/' + encodeURIComponent(item.mapFilterValue),
    )
  }

  /**
   * Get list values.
   *
   * @return {array} Other than title and icon. Values for mapFilterValue can be:
   * * For  mapFilterType: "c" - available categories can be found here:
   *    https://developers.google.com/places/web-service/supported_types
   * * For mapFilterType: "q" - can be pretty much any search query
   */
  getListItems = () => {
    const { intl, countryIsoCode } = this.props

    const commonProps = {
      rightIcon: 'right',
    }

    // TODO: Later maybe add proper translation for "Petrol Stations", this is ok for now.
    const isUk = countryIsoCode && countryIsoCode.toLowerCase() === 'gb'
    const gasStationText = isUk
      ? 'Petrol Stations'
      : intl.formatMessage(intlMessages.servicesListGasStations)

    return [
      {
        ...commonProps,
        leftIcon: ['far', 'gas-pump'],
        mapFilterType: 'c',
        mapFilterValue: 'gas_station',
        name: gasStationText,
        hideArrow: true,
      },
      {
        ...commonProps,
        leftIcon: ['far', 'key'],
        mapFilterType: 'c',
        mapFilterValue: 'locksmith',
        name: intl.formatMessage(intlMessages.servicesListLocksmith),
        hideArrow: true,
      },
      {
        ...commonProps,
        leftIcon: ['far', 'truck-tow'],
        iconWidth: 30,
        mapFilterType: 'q',
        mapFilterValue: 'tow truck',
        name: intl.formatMessage(intlMessages.servicesListTowTruckServices),
        hideArrow: true,
      },
      {
        ...commonProps,
        leftIcon: ['far', 'user-police-tie'],
        mapFilterType: 'c',
        mapFilterValue: 'police',
        name: intl.formatMessage(intlMessages.servicesListPolice),
        hideArrow: true,
      },
    ]
  }

  render() {
    const { intl, features } = this.props

    const foundedFeature = features.find(f => f.id == 'services')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.servicesHeader)

    return (
      <Layout>
        <Content>
          <PageTitle title={title} setTitle={true} showBackMobile={true} />
          <Container className={styles.container}>
            <List
              items={this.getListItems()}
              classNameListItem={styles.listItem}
              classNameLeftIconSvg={styles.leftIcon}
              onClick={this.listItemClick}
              isServices={true}
              styleVariationDesktop='blocks'
              noResultsMessage={intl.formatMessage(intlMessagesApp.appGlobalNoResults)}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

ServicesList.propTypes = {
  labels: PropTypes.object.isRequired,
  intl: PropTypes.object,
  router: PropTypes.object,
}

export default withRouter(injectIntl(ServicesList))
